import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as transactionsSelectors from 'store/transactionsSlice/transactionsSelectors';
import { transactionActions } from 'store/transactionsSlice/transactionsSlice';

const useRealTimeCameraStreamBadge = (cameraId) => {
    const dispatch = useDispatch();
    const videoWallCamerasRealTimeUpdated = useSelector(transactionsSelectors.selectVideoWallCamerasRealTimeUpdated);
    const isRealTimeUpdated = videoWallCamerasRealTimeUpdated.includes(cameraId);

    useEffect(() => {
        let timer;
        if (isRealTimeUpdated) {
            timer = setTimeout(() => {
                dispatch(transactionActions.resetVideoWallCamerasRealTimeUpdated());
            }, 10000);
        }
        return () => clearTimeout(timer);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [videoWallCamerasRealTimeUpdated]);

    return isRealTimeUpdated;
};

export default useRealTimeCameraStreamBadge;
